import { render, staticRenderFns } from "./IntroductionForm.vue?vue&type=template&id=6d1cdd47&scoped=true"
import script from "./IntroductionForm.vue?vue&type=script&lang=js"
export * from "./IntroductionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1cdd47",
  null
  
)

export default component.exports